import React from "react";
import { useState } from "react";
import { ReactComponent as UpperArrow } from "assets/images/icons/upper-arrow.svg";
import { ReactComponent as EditIcon } from "assets/images/icons/Row_Edit_Action.svg";
import { ReactComponent as TrashIcon } from "assets/images/icons/Row_Delete_Actions.svg";
import { ReactComponent as CalendarIcon } from "assets/images/icons/calendar.svg";
import { ReactComponent as CreditCardIcon } from "assets/images/icons/credit-card.svg";

import * as globalUtils from "../../../../../../helpers/utils";
import { Button } from "primereact/button";
import StyleWrapper from "./style";
import { Divider } from "@mui/material";
import { useFormik } from "formik";
import { Calendar } from "primereact/calendar";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import IdentificationDetails from "./components/identificationDetails";
import ApplicantDetails from "./components/applicantDetails";
import WaselDetails from "./components/waselDetails";
import ReusableRadioBlock from "./components/reusableRadioBlock";
import OtherVehicleInfo from "./components/otherVehicleInfo";
import OtherDriverDetails from "./components/otherDriverDetails";
import drivers from "application/motor/components/PolicySec/Drivers/drivers";
import { useTranslation } from "react-i18next";


const OtherInformation = (props) => {
  const [opened, setOpened] = useState(false);
  const { t, i18n } = useTranslation();
  const [showAddDriver, setShowAddDriver] = useState(false);
  const [infoToEdit, setDriverToEdit] = useState();
  const RadioQuestionsList = [
    {
      code: 'q1',
      text: 'Mailing address',
      answer:'wassel',
      options: [
        {value: 'wassel', name: 'Wassel'},
        {value: 'home', name: 'Use my home address as a  mailing address'},
        {value: 'poBox', name: 'P.O Box'},
      ]
    },
    {
      code: 'q2',
      text: 'Are you a related party?',
      answer:'false',
      options: [
        {value: 'false', name: 'No'},
        {value: 'true', name: 'Yes'},
      ]
    },
    {
      code: 'q3',
      text: 'Are You a Member of the Royal Family?',
      answer:'false',
      options: [
        {value: 'false', name: 'No'},
        {value: 'true', name: 'Yes'},
      ]
    },
    {
      code: 'q4',
      text: 'Are you politically exposed person (PEP)',
      answer:'false',
      options: [
        {value: 'false', name: 'No'},
        {value: 'true', name: 'Yes'},
      ]
    },
    {
      code: 'q5',
      text: 'Do you have a Policyholder’s Authorized Attorney ?',
      answer:'false',
      options: [
        {value: 'false', name: 'No'},
        {value: 'true', name: 'Yes'},
      ]
    },
    {
      code: 'q6',
      text: 'Are You The Policy owner? ',
      answer:'false',
      options: [
        {value: 'false', name: 'No'},
        {value: 'true', name: 'Yes'},
      ]
    },
  ]
  const handleDriverRemove = () => {};

  const formik = useFormik({
    initialValues: {
      idNumber: "",
      yob: "",
    },
    validate: (data) => {
      let errors = {};

      if (!data.idNumber) {
        errors.idNumber =  t("TP-claim.home-nationalId");
      } else if (!globalUtils.isValidSaudiIDOrIQama(data.idNumber)) {
        errors.idNumber = t("TP-claim.home-nationalId-valid");
      }

      if (!data.yob) {
        errors.yob = t("TP-claim.home-yob");
      }
      return errors;
    },

    onSubmit: (data) => {
      ////     // console.log(data);
    },
  });
  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };
  const getYobList = () => {
    return globalUtils.isSaudi(formik.values.nationalId)
      ? globalUtils.getHijriYearOfBirthList()
      : globalUtils.getGregYearOfBirthList();
  };

  ////     // console.log(props.defaultValues);
  return (
    <StyleWrapper className={  `${i18n.language ==='ar'? ' ar' : ''}`}>
      <div
        onClick={() => setOpened(!opened)}
        className={"accordion-header d-flex justify-content-between align-items-center"}
      >
        <h5 className="fm-bliss2-bold">{t("MotorEn.OtherVehicle")}</h5>
        <div className="Icon-Div">
                        {opened ? (
                          <i className="pi pi-chevron-up accordianIcon up-acc"></i>
                        ) : (
                          <i className="pi pi-chevron-down accordianIcon down-acc"></i>
                        )}
                      </div>
      </div>
      {opened && (
        <div className="infos-section">
          {/* <IdentificationDetails submitForm={props.submitAllForms} defaultValues={props.defaultValues}/> */}
          {/* <ApplicantDetails className='mt-5' submitForm={props.submitAllForms} defaultValues={props.defaultValues}/> */}
          <OtherVehicleInfo submitForm={props.submitAllForms} defaultValues={props.defaultValues} businessColor={props.businessColor} />
          {/* <WaselDetails className='mt-5'submitForm={props.submitAllForms} defaultValues={props.defaultValues}/> */}
          {/* {RadioQuestionsList?.map((item, i) => <ReusableRadioBlock key={`ReusableRadioBlock_${i}`} question={item} className='mt-5'/>)} */}
          <div className="info-card form_card mt-5">
            <div className="header">
              <h5>{t("MotorEn.OtherDrivers")}</h5>
            </div>
            <Divider className="my-3" />
            {props.driversList.map( (driver, index) => 
              <OtherDriverDetails defaultValues={props.defaultValues} driver={driver} key={`OtherDriverDetailsCar_${index}`} />
            )}
          </div>
          
        </div>
      )}
    </StyleWrapper>
  );
};

export default OtherInformation;
